import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { appTheme } from "./theme";
import { loadTheme } from "@fluentui/react";

// Create a client
const queryClient = new QueryClient();

initializeIcons();
loadTheme(appTheme);

let isOfficeInitialized = false;

const render = (Component) => {
    ReactDOM.render(
        <QueryClientProvider client={queryClient}>
            <AppContainer>
                <Component isOfficeInitialized={isOfficeInitialized} />
            </AppContainer>
        </QueryClientProvider>,
        document.getElementById("container")
    );
};

/* Render application after Office initializes */
Office.onReady(() => {
    Office.addin.setStartupBehavior(Office.StartupBehavior.load);
    Office.addin.showAsTaskpane();
    isOfficeInitialized = true;
    render(App);
});

/* Initial render showing a progress bar */
render(App);

if (module.hot) {
    module.hot.accept("./components/App", () => {
        const NextApp = require("./components/App").default;
        render(NextApp);
    });
}
